export default [
  {
    path: "/pusdatin/roles",
    name: "pusdatin-roles",
    component: () => import("../../views/rektorat/pusdatin/Roles.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Pusdatin", url: "/submenu/pusdatin" },
        { title: "Roles", active: true },
      ],
      pageTitle: "Roles",
    },
  },
  {
    path: "/pusdatin/login-as",
    name: "pusdatin-login-as",
    component: () => import("../../views/rektorat/pusdatin/LoginAs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Pusdatin", url: "/submenu/pusdatin" },
        { title: "Login As", active: true },
      ],
      pageTitle: "Login As",
    },
  },
];
